// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6976":"5841a7af5773b65c","23464":"2e9ffaf4a4eb25e8","56623":"e2575e355f605537"}[chunkId] + ".css";
};